/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Messaging Modal meta selectors
 */

import { compose } from 'redux'
import { selectMessagingModalMeta } from './index'

export const selectCanceled = compose((meta) => meta.canceled, selectMessagingModalMeta)

export const selectError = compose((meta) => meta.error, selectMessagingModalMeta)

export const selectFetching = compose((meta) => meta.fetching, selectMessagingModalMeta)

export const selectFetchingKey = compose((meta) => meta.fetchingKey, selectMessagingModalMeta)
